import styled from "styled-components";

import { DrawerHeaderStyled } from "./header.styled";

export const MenuDrawerHeaderStyled = styled(DrawerHeaderStyled)`
  .DrawerHeaderTitle {
    margin-inline-end: auto;
  }
`;
